import { Pipe, PipeTransform } from '@angular/core';
import { Subscription } from '@greco/sales-subscriptions';

@Pipe({ name: 'allowBankPayments' })
export class AllowBankPaymentsPipe implements PipeTransform {
  transform(subscription: Subscription): boolean {
    return subscription.paymentTypes ? subscription.paymentTypes.some(pt => pt === 'bank') : false;
  }
}
